<google-map [options]="mapOptions$ | async" width="100%" [height]="height" (mapClick)="updateControlIfUnset($event)">
  <map-marker [options]="markerOptions$ | async" (mapDragend)="updateControl($event)"></map-marker>
</google-map>
<div *ngIf="tooltip" class="geo__tooltip">{{ tooltip }}</div>
